<template>
  <Card @clicked="$emit('clicked')">
    <v-row slot="title" class="flex-nowrap justify-space-between align-center" no-gutters>
      <span class="body-2 font-weight-bold text-truncate">
        <v-icon left>mdi-store</v-icon>
        {{ cliente.nome_fantasia }}
      </span>
      <v-btn small text class="pa-0">
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
    </v-row>
    <v-row slot="body" no-gutters>
      <v-col cols="12">
        <v-list-item>
          <v-list-item-title class="d-flex align-center body-2">
            <v-icon left small>mdi-badge-account-horizontal-outline</v-icon>
            {{ cliente.cpf_cnpj }}
          </v-list-item-title>
        </v-list-item>
        <v-list-item>
          <v-list-item-title class="d-flex align-center body-2">
            <v-icon left small>mdi-account</v-icon>
            {{ cliente.contato }}
          </v-list-item-title>
        </v-list-item>
      </v-col>
      <v-col cols="12" v-if="!cliente.id_cliente">
        <v-divider></v-divider>
      </v-col>
      <v-col cols="12" v-if="!cliente.id_cliente" class="px-4 py-2">
        <v-icon small left color="error">mdi-circle</v-icon>
        <span class="caption font-italic">Não sincronizado!</span>
      </v-col>
    </v-row>
  </Card>
</template>

<script>
import Card from './Card';
import Cliente from '@/domain/Cliente';

export default {
  name: 'CardCliente',
  props: {
    cliente: {
      type: Object,
      default: () => new Cliente()
    },
    flat: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Card,
  }
}
</script>

<style>

</style>